import * as tslib_1 from "tslib";
import * as shared from '../../shared';
import weibo from './comps/weibo.vue';
import fixedTop from './comps/fixedTop.vue';
import fixedBottom from './comps/fixedBottom.vue';
import articleHtml from '../components/articleHtml.vue';
import { Component, Vue } from 'vue-property-decorator';
let Article = class Article extends Vue {
    constructor() {
        super(...arguments);
        this.weibo = [];
        this.article = {};
        this.articleCount = {};
    }
    async mounted() {
        // utils.trackEvent(`社区文章页`, '访问')
        this.article = await shared.getArticle(this.$route.query.id);
        this.weibo = await shared.getWeiboList(this.$route.query.id, 'ARTICLE');
        this.articleCount = await shared.getWeiboCount(this.$route.query.id);
    }
};
Article = tslib_1.__decorate([
    Component({
        components: {
            weibo,
            fixedTop,
            fixedBottom,
            articleHtml,
        },
    })
], Article);
export default Article;
